import React from "react";
import { useTranslation } from "react-i18next";
import SelectInput from "../../common/selectInput";
import styles from "./languageSwitcher.module.css";

export const LanguageSwitcher = () => {
  const { t } = useTranslation();

  return (
    <SelectInput
      ariaLabel={t("dashboard_single_listing_popup_languages_dropdown")}
      tabSelectsValue={false}
      classNameWrap={styles.wrapper}
      className={styles.select}
      inputId="language-select"
      name="language"
      options={[{ value: "en", label: "EN" }]}
      value={{ value: "en", label: "EN" }}
    />
  );
};
